/**
 * Sales Negotiation: which scenarios people can play right now.
 *
 * 'live'         playable.
 * 'coming-soon'  the scenario, its characters and all their data stay in the code, but it is GATED:
 *                the Sales landing shows it as "coming soon" (not startable) and counts only live
 *                characters; the Voice Room shows a coming-soon screen for a direct link; the backend
 *                refuses to start a call or score one (even by a direct URL) and never hands out one of
 *                its characters; the clip generator makes no audio for it.
 *
 * To open a scenario, change its line here and run `npm run sync:characters` in backend/: the backend's
 * copy of this table is generated from it (see scripts/sync-sales-characters.mjs). Nothing else changes.
 *
 * No imports and no browser APIs, so it loads in the browser, in Node scripts and in tests.
 */
export const SCENARIO_STATUS = {
  'cold-call-mastery':   'live',
  'objection-defense':   'live',
  'negotiation-tactics': 'live',
  'enterprise-closing':  'live',
};

export const isScenarioLive = (scenarioKey) => SCENARIO_STATUS[scenarioKey] === 'live';

/** How a scenario is described to a person when it is not open. */
export const COMING_SOON_MESSAGE = 'This scenario is coming soon.';

/** The scenario names people read (Enterprise Closing is shown as "Price & Closing" on the Sales page). */
export const SCENARIO_TITLES = {
  'cold-call-mastery':   'Cold Call Mastery',
  'objection-defense':   'Objection Defense',
  'negotiation-tactics': 'Negotiation Tactics',
  'enterprise-closing':  'Price & Closing',
};
